import _ from "lodash";
import React from "react";
import {
  ToggableDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "./Dropdown";

import IconYes from "../../../assets/images/icon_yes.svg";
import IconNo from "../../../assets/images/icon_no.svg";

export default ({ filter, onChange }) => {
  const value = filter ? filter.value : null;

  return (
    <ToggableDropdown className="status-dropdown">
      <DropdownToggle caret>
        {value === null && <span>Status</span>}
        {value === "none" && <span>None</span>}
        {value === "true" && <i className="fa !tw-text-black !tw-w-full !tw-m-0 fa-check"></i>}
        {value === "false" && <i className="fa !tw-text-black !tw-w-full !tw-m-0 fa-times"></i>}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => onChange(null)}>None</DropdownItem>
        <DropdownItem onClick={() => onChange("true")}>
          <i className="fa !tw-text-black !tw-w-full !tw-m-0 fa-check"></i>
        </DropdownItem>
        <DropdownItem onClick={() => onChange("false")}>
        <i className="fa !tw-text-black !tw-w-full !tw-m-0 fa-times"></i>
        </DropdownItem>
      </DropdownMenu>
    </ToggableDropdown>
  );
};
